import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';

class RecipeCard extends React.Component {
  render() {
    const { idRecipeCard, idImg, srcImg, idCardName, mealName } = this.props;
    return (
      <div data-testid={ idRecipeCard } className="recipe-card-custom">
        <div className="recipe-card-image-wrapper">
          <Image
            data-testid={ idImg }
            src={ srcImg }
            alt={ `Foto de ${mealName}` }
            className="linkImage"
            loading="lazy"
          />
          <div className="recipe-card-badge">
            <span>Gourmet</span>
          </div>
        </div>
        <div className="recipe-card-content">
          <h3 data-testid={ idCardName } className="recipe-card-title">{mealName}</h3>
          <span className="recipe-card-explore">Ver receita completa &rarr;</span>
        </div>
      </div>
    );
  }
}

RecipeCard.propTypes = {
  idRecipeCard: PropTypes.string.isRequired,
  idImg: PropTypes.string.isRequired,
  srcImg: PropTypes.string.isRequired,
  idCardName: PropTypes.string.isRequired,
  mealName: PropTypes.string.isRequired,
};

export default RecipeCard;

